import { Label, Typography } from '@musinsa/mds';
import { SERVICE, useDeviceInfo } from '@musinsa/packages-device-detection';
import clsx from 'clsx';
import type { FC } from 'react';

const DISPLAY_NAME = 'ProductInformation.CouponBadge';

interface Props {
  className?: string;
}

export const CouponBadge: FC<Props> = ({ className }) => {
  const { service } = useDeviceInfo();
  const is29CM = service === SERVICE['29CM'];

  return (
    <Label
      className={className}
      variant={is29CM ? undefined : 'blueOpacity'}
      bgColor={is29CM ? 'gray-500' : undefined}
      bgOpacity="10"
    >
      <Typography
        colorScheme={is29CM ? 'gray-600' : undefined}
        className={clsx(!is29CM && 'text-[#245EFF]')}
        size="11"
      >
        쿠폰
      </Typography>
    </Label>
  );
};

CouponBadge.displayName = DISPLAY_NAME;
